import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class NdisNumberValidator {
  constructor() {}

  ndisNumberValidator(
    formField: AbstractControl
  ): { [key: string]: any } | null | void {
    // Check if field is Required
    const isEmpty =
      formField.value === '' ||
      formField.value === null ||
      formField.value === undefined;
    if (isEmpty) {
      return { required: { valid: false, value: formField.value } };
    }

    // Must only be numbers
    const isAllNumbers = /^\d+$/.test(formField.value);
    if (!isAllNumbers) {
      return { notAllNumbers: { valid: false, value: formField.value } };
    }

    // Must start with 43
    const firstNumber = /^(4|5)/.test(formField.value);
    if (!firstNumber) {
      return { not4or5: { valid: false, value: formField.value } };
    }

    // Minimum 9 digits
    const notEnough = /^\d( ?\d){0,7}$/.test(formField.value);
    if (notEnough) {
      return { min: { valid: false, value: formField.value } };
    }

    // Maximun 9 digits
    const tooMany = /^\d( ?\d){9,}$/.test(formField.value);
    if (tooMany) {
      return { max: { valid: false, value: formField.value } };
    }

    // Must be 9 digits long
    const correctLength = formField.value.length === 9;
    if (correctLength === false) {
      return { wrongLength: { valid: false, value: formField.value } };
    }
  }
}
